// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar-module--container--JkjiK","navList":"navbar-module--navList--23gsu","logo":"navbar-module--logo--OHcGr","link":"navbar-module--link--1TQod"};